<script setup>
defineProps({
    value: String,
    required: Boolean
});
</script>

<template>
    <label
        class="block font-bold text-sm"
        :class="{'after:text-red-500 after:content-[\'*\'] after:relative after:-top-1 after:text-xs after:-right-1': required}"
    >
        <span v-if="value">{{ value }}</span>
        <span v-else><slot /></span>
    </label>
</template>
